module.exports = __webpack_public_path__ + "img/family-silhouette.c9fdb2c4.svg";